export const environment = {
  production: false,
  appVersion: require("../../package.json").version + " |",
  // apiUrl: "https://api-lease.almamoon.sa/api/",
  apiUrl: "https://api-lease-uat.almamoon.sa/api/",
  logosUrl: "https://api-lease.almamoon.sa/logo/",
  SaudiVatPercentage: 0.15,
};
